module.exports = __webpack_public_path__ + "Flag-574.82c830d85a7dcb9d6024b573b2cfb1fc.svg";